var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaixa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3057.396,
    height: 1100.536,
    viewBox: "0 0 808.936 291.184",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M808.936.232L.186 0 0 291.184l36.768-12.553 36.734 12.553 36.761-12.553 36.748 12.553 36.748-12.553 36.742 12.553 36.735-12.553 36.716 12.553 36.736-12.553 36.741 12.553 36.742-12.553 36.742 12.553 36.742-12.553 36.73 12.553 36.74-12.553 36.73 12.553 36.729-12.553 36.722 12.553 36.729-12.553 36.717 12.553 36.729-12.553 37.366 12.553z",
    fill: "#f2f09e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M808.936.232L.186 0 0 284.201l36.768-12.552L73.502 284.2l36.761-12.552 36.748 12.552 36.748-12.552 36.742 12.552 36.735-12.552 36.716 12.552 36.736-12.552L367.43 284.2l36.742-12.552 36.742 12.552 36.742-12.552 36.73 12.552 36.74-12.552 36.73 12.552 36.729-12.552 36.722 12.552 36.729-12.552 36.717 12.552 36.729-12.552 37.366 12.23z",
    fill: "#f5e02c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaixa);
export default __webpack_public_path__ + "static/media/faixa.a77a5b960a0cfc753613ad813cde476b.svg";
export { ForwardRef as ReactComponent };